import { render, staticRenderFns } from "./ExportReturn.vue?vue&type=template&id=52102c16&scoped=true&"
import script from "./ExportReturn.vue?vue&type=script&lang=js&"
export * from "./ExportReturn.vue?vue&type=script&lang=js&"
import style0 from "./ExportReturn.vue?vue&type=style&index=0&id=52102c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52102c16",
  null
  
)

export default component.exports